import checkout from "./form";

const {
  formField: {
    taxId,
    conpanyName,
    otherBillType,
    managingUnit,
    managingUnitTaxId,
    notificationReceivingAgency,
    releaseDate,
    representative,
  },
} = checkout;

const initialValues = {
  [taxId.name]: "",
  [otherBillType.name]: "",
  [conpanyName.name]: "",
  [managingUnit.name]: "",
  [managingUnitTaxId.name]: "",
  [notificationReceivingAgency.name]: "",
  [releaseDate.name]: "",
  [representative.name]: "",
};

export default initialValues;
